import type { ShowMoreTilesData } from '../../../../analytics/event-tracking/trackShowMoreTiles';
import { ContentBrick } from '../../../../app-kit/components/ContentBrick/ContentBrick';
import { PropertyCarousel } from '../../../../app-kit/components/PropertyCarousel/PropertyCarousel';
import type { PropertyTileProps } from '../../../../app-kit/components/PropertyTile/PropertyTile';
import type { WebLinkProps } from '../../../../app-kit/components/WebLink/WebLink';
import { WebLink } from '../../../../app-kit/components/WebLink/WebLink';
import { spacingHelper, typographyHelper } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';

const SearchPageWebLink = styled(WebLink)`
  text-align: center;
  width: fit-content;
  float: none;
  ${typographyHelper('overline')};
  display: block;
  margin: ${spacingHelper('extraSmall auto 0')};
`;

interface CarouselPropertyCollectionProps {
  title: string;
  subtitle?: string | null;
  properties: PropertyTileProps[];
  tracking?: { showMoreProperties: ShowMoreTilesData } | null;
  searchPageWebLink?: WebLinkProps | null;
}

export const CarouselPropertyCollectionBrick: FunctionComponent<
  CarouselPropertyCollectionProps
> = ({ title, subtitle, properties, tracking, searchPageWebLink }) => {
  return (
    <ContentBrick title={title} subtitle={subtitle}>
      <PropertyCarousel
        key={properties.map((p) => p.path).join('')}
        properties={properties}
        tracking={tracking?.showMoreProperties}
      />
      {searchPageWebLink && (
        <SearchPageWebLink
          title={searchPageWebLink.title}
          url={searchPageWebLink.url}
          isExternal={searchPageWebLink.isExternal}
          variant={searchPageWebLink.variant}
          tracking={searchPageWebLink.tracking}
        />
      )}
    </ContentBrick>
  );
};
